import React, { useState,useEffect } from 'react';
import 'react-calendar/dist/Calendar.css';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { GetTurnos } from '../../actions';
import Swal from 'sweetalert2';
import { AiFillEdit } from "react-icons/ai";
import CustomMenu from './customMenuTurnos/CustomMenu';


Modal.setAppElement('#root');

const Turnos = () => {
  const dispatch = useDispatch()
  const doctorTurnos = useSelector(state=>state.turnos)
  const [turnosUpdated, setTurnosUpdated] = useState(false); // nuevo estado
  const [comprobante, setComprobante] = useState(false)
  const [nombre, setNombre]  = useState('')



  const [ActualPage, SetActualPage] = useState(1)
    const [turnosPP, SetTurnosPP] = useState(8)
    const [order, setOrder] = useState('')
    const LastTurn = Math.ceil(ActualPage * turnosPP)
    const FirstTurn = LastTurn - turnosPP
    const ActualTurns = doctorTurnos.slice(FirstTurn, LastTurn)

  

  useEffect(() => {
    dispatch(GetTurnos(1))
    
    if(turnosUpdated===true){
      handleUpdateTurnos()
    }
  }, [turnosUpdated]);
  
  
  const handleUpdateTurnos = () => {
    setTurnosUpdated(!turnosUpdated);
  };

  const handleComprobante = async (turno) => {
  setComprobante (state => !state)
  setNombre(turno.comprobante)
}

  return (

  
    <div className='flex flex-col w-full p-8 items-center font-roboto'>

      <div>
        
        <button 
        className='bg-background_home font-bold font-roboto text-white rounded-l-xl w-16'
        disabled={ActualPage <= 1 ? true : false} onClick={() => SetActualPage(ActualPage - 1)}>{`<`}</button>
        <span className='font-roboto font-bold px-4'>{ActualPage}</span>
        <button 
         className='bg-background_home font-bold font-roboto text-white rounded-r-xl w-16'
        onClick={() => SetActualPage(ActualPage + 1)}> {`>`} </button>
     </div>



      <div className='flex flex:row'>
      <div>
      <div className='flex flex-row font-medium'>
        <div className='border w-40 p-2 flex items-center justify-center bg-background_home text-white'>Fecha</div>
        <div className='border w-40 p-2 flex items-center justify-center bg-background_home text-white'>Horario</div>
        <div className='border w-80 p-2 flex items-center justify-center bg-background_home text-white'>Usuario</div>
        <div className='border w-40 p-2 flex items-center justify-center bg-background_home text-white'>Asistencia</div>
        <div className='border w-40 p-2 flex items-center justify-center bg-background_home text-white'>Pago</div>
        <div className='border w-40 p-2 flex items-center justify-center bg-background_home text-white'>Comprobante</div>
        <div className='border w-20 p-2 flex items-center justify-center bg-background_home text-white'>Editar</div>
      </div>


      {doctorTurnos&&
 ActualTurns.map((turno,index) => (
    <div key={index} className='flex flex-row'>
      <div className='border w-40 p-2 flex items-center justify-center'>
        <p>{turno.date}</p>
      </div>

      <div className='border w-40 p-2 flex items-center justify-center'>
        <p>{turno.initTime+" - "+turno.endTime}</p>
      </div>

      <div className='border w-80 p-2 flex items-center justify-center'>
        <p>{turno.user.name+" "+turno.user.lastName}</p>
      </div>

      <div className='border w-40 p-2 flex items-center justify-center'>
        <p>{turno.status}</p>
      </div>
      <div className='border w-40 p-2 flex items-center justify-center'>
        <p>{turno.comprobante && turno.paymentStatus==="Pendiente de Pago"?"En Revision":turno.paymentStatus}</p>
      </div>
                  
      <div className='border w-40 max-h-12 p-2 flex items-center justify-center'>
        <p>{turno.comprobante? <button onClick={() => handleComprobante(turno)}
                   className="bg-indigo-600 text-white flex justify-center items-center
                   font-medium  text-[10px] w-12 h-10 px-4 sm:text-[13px] sm:w-24 rounded ml-2 sm:ml-0">
                  Ver Comprobante</button>  :"No"}</p>
      </div>
                  
      <div className='border w-20 p-2 flex items-center justify-center'>
      <CustomMenu id={turno.id} handleUpdateTurnos={handleUpdateTurnos}/>
      </div>  
             
    </div>
  ))}
      </div>
  </div>
        {
        comprobante ?
        <div className='w-2/3 flex justify-center items-center pt-12 flex-col'>
        <iframe src={`http://localhost:3001/images/${nombre}`} width="100%" height="500px"></iframe> 
        <button  onClick={() =>setComprobante(false)}
        className='bg-red-600 text-white flex justify-center items-center
        sm:inline-block font-medium  text-[10px] w-12 h-10 px-4 sm:text-[13px] sm:w-24 rounded ml-2 sm:ml-0'>CERRAR</button>
        </div>
        : null
        }
      </div>

  );
};

export default Turnos;